import Navigator from './components/Navigation';
import './style.css';
import './workDetailPage/style_works.css';
import './font.css';
import { Waiting } from './components/Waiting';
import {WorkTitle} from './workDetailPage/WorkTitle';
import mainImage from './image/works/outlinkMainImage.webp';
import { WorkTextSection } from './workDetailPage/WorkTextSection';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { MainImage } from './workDetailPage/WorkMainImage';
import expert from './image/works/work6_img_expert.webp';
import { WorkImage } from './workDetailPage/WorkImage';
import chart1 from './image/works/work6chart1.webp';
import goalimage from './image/works/work6Goal.webp';
import { WorkFullImage } from './workDetailPage/WorkFullImage';
import survey from './image/works/work6survey.webp';
import ecosystem  from './image/works/work6ecosystem.webp';
import direction  from './image/works/work6direction.webp';
import BackButton from './components/BackButton';
import userflow from './image/works/work6userflow.webp';
import research1 from './image/works/work6research1.webp';
import research2 from './image/works/work6research2.webp';
import research3 from './image/works/work6research3.webp';
import design1 from './image/works/work6design1.webp';
import design2 from './image/works/work6design2.webp';
import design3 from './image/works/work6design3.webp';
import design4 from './image/works/work6design4.webp';
import { Wavedivider } from './components/Wavedivider';
import result1 from './image/works/work6result1.webp';
import result2 from './image/works/work6result2.webp';
import NextItem from './components/NextItem';
import thumbnail10 from './image/workThumbnails/thumbnail10.webp';
import { useMetaTags } from './utils/useMetaTags';
import ProtectedPage from './components/ProtectedPage';
import { hashPasswordsFromEnv } from './utils/passwordUtils';

//OutlinkAds

function Work6(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    useMetaTags({
      title: 'New Outlink-Type Ads - Lynkim',
      description: 'Introducing a new outlink-type advertisement for small businesses.',
      image: '/ogimage.png',
    });
    
    // 비밀번호는 .env.local의 REACT_APP_WORK_PASSWORD에 저장 (gitignored)
    const password = hashPasswordsFromEnv(process.env.REACT_APP_WORK_PASSWORD);
    
    return (
      // <ProtectedPage password={password} description="이 페이지는 비밀번호로 잠겨있어요">
      <>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      <div className='fadeIn '>
        <WorkTitle 
          title={'New Outlink-Type Ads'} 
          description={'Introducing a new outlink-type advertisement for small businesses.'} 
          team={'Karrot(Daangn)'} 
          role={'Service Planning, UXUI Design'} 
          period={'2023.04 - 2023.07'}
          titleKo={'신규 아웃링크형 광고'}
          descriptionKo={'소상공인을 위한 새로운 아웃링크형 광고 상품을 출시했습니다.'}
          teamKo={'당근마켓(Karrot)'}
          roleKo={'서비스 기획, UXUI 디자인'}
        />
      </div>
      <MainImage image={mainImage}/>

        <WorkTextSection 
          title={'Background'} 
          description={<div>
              On Karrot, there are small advertisers who spend less than 1 million KRW per month on ads and professional advertisers who spend more than 1 million KRW. <br/> The expert mode has a campaign &gt; ad group &gt; ad structure, which is challenging for small business owners who are not familiar with advertising to understand and use effectively. 
            </div>} 
          subDescription={'당근에는 월 광고비 100만 원 미만의 소상공인과 100만 원 이상의 전문 광고주가 공존합니다. 전문가 모드는 캠페인 &gt; 광고그룹 &gt; 광고 구조로 되어 있어, 광고에 익숙하지 않은 소상공인이 이해하고 사용하기에 어렵습니다.'}
        />
        <WorkImage image={expert} description={'Creating “Outlink Ads” on an Expert Mode'} isMaxheight={false} isbottomPadding={false} />
        <WorkTextSection 
          description={<div>
              In the expert mode platform for professional advertisers, the "Outlink Ads" product is exclusively offered. We observed that many small advertisers are migrating to the expert mode to use "Outlink Ads." Recognizing the strong demand for a simple and easy-to-use outlink ad product on mobile, we decided to add the outlink ad product to the easy mode for advertising.
          </div>}
          subDescription={'전문 광고주용 전문가 모드에서만 제공되던 “아웃링크 광고”를 사용하기 위해 많은 소상공인이 전문가 모드로 이동하고 있었습니다. 모바일에서도 간단하고 쉬운 아웃링크 광고에 대한 수요가 높다고 판단하여, 쉬운 모드에도 아웃링크 광고를 추가하기로 했습니다.'}
        />
        <WorkImage image={chart1} isMaxheight={true} isbottomPadding={true} />
        <WorkFullImage image={survey} isRoundedCorner={false} isBackgroundColor={false} isMargin={true} isBottomMargin={true} />
        
        <WorkTextSection 
          title={'User Research'} 
          description={<div>
              To understand the situations in which small business owners primarily utilize outlink advertising, I analyzed the URLs added to "Business Profile Posts" across different industries.</div>} 
          subDescription={'소상공인이 아웃링크 광고를 주로 활용하는 상황을 이해하기 위해 다양한 업종의 “비즈프로필 게시글”에 추가된 URL을 분석했습니다.'}
        />
        <div className='image-center margin48 horizontal-layout'>
        <WorkFullImage image={research1} isMargin={false} isBackgroundColor={true} isRoundedCorner={true} isBottomMargin={true} description='Example of a Post'/>   
        <WorkFullImage image={research2} isMargin={false} isBackgroundColor={true} isRoundedCorner={true} isBottomMargin={true} description='Share by Outlink Type'/>   
        <WorkFullImage image={research3} isMargin={false} isBackgroundColor={true} isRoundedCorner={true} isBottomMargin={true} description='Outlink by Usecase'/>   
        </div>

        <WorkTextSection 
          title={'Goal'} 
          description={<div>
              Karrot's vision is to connect local residents with neighborhood businesses, allowing users to obtain useful local shop information and establish relationships as regular customers.
              We had the mission of launching Outlink-ads for small businesses while ensuring that the number of business owners using Karrot's "Biz Profile" does not decrease.
              <br/>Accordingly, Outlink-ads were targeted primarily at <b>business owners who provide services nationwide</b>, rather than local businesses.
              </div>}
          subDescription={'당근의 비전은 지역 사용자와 동네 상점을 연결하여, 유용한 상점 정보를 제공하고 단골과의 관계를 형성하도록 돕는 것입니다. “비즈프로필” 사용자 수를 유지하면서 소상공인을 위한 아웃링크 광고를 출시하는 것이 우리의 미션이었습니다. 이에 따라 아웃링크 광고는 지역 상점이 아닌, <b>전국 단위로 서비스를 제공하는 사업자</b>를 주요 타깃으로 삼았습니다.'}
        />
        <WorkImage image={goalimage} isMaxheight={false} isbottomPadding={true}/>
        <div style={{backgroundColor:'var(--color-bg-inverse)'}}>
        <WorkTextSection 
              title={<div>Karrot's Ads Ecosystem</div>} isWhiteText={true} />
          <WorkImage image={ecosystem} isMaxheight={false} isbottomPadding={true}/>
        </div>
        <WorkTextSection 
          title={'Design Direction'} 
          description={<div>
              Unlike outlink ads provided to professional advertisers, the UX direction for outlink ads aimed at small advertisers has been set to ensure that anyone can use them easily.</div>}
          subDescription={'전문 광고주를 대상으로 제공되는 아웃링크 광고와 달리, 소상공인 대상 아웃링크 광고는 누구나 쉽게 사용할 수 있도록 UX 방향을 설정했습니다.'}
        />
        <WorkFullImage image={direction} isRoundedCorner={false} isBackgroundColor={false} isBottomMargin={true} isMargin={true}/>
      <WorkTextSection title='UXUI Design'/>
      <WorkFullImage image={userflow}/>
      
      <WorkTextSection 
          title={<div>Key Design1.<br/>To help each advertiser choose the suitable ad</div>} 
          description={<div>
              Encourage online advertisers to choose "website ads", while guiding offline businesses owners to choose "Business Profile ads".</div>}
          subDescription={'온라인 광고주에게는 “웹사이트 광고”를, 오프라인 사업자에게는 “비즈프로필 광고”를 선택하도록 유도했습니다.'}
      />
      <WorkImage image={design1} isMaxheight={true} isbottomPadding={false}/>
      
      <WorkTextSection 
          title={<div>Key Design2.<br/>To reduce decision-making complexity</div>} 
          description={<div>
              By analyzing the preference and click-through rate (performance) of each CTA used in outlink ads within expert mode, we identified the most effective options. This allows us to offer a minimal selection of CTAs, reducing decision-making complexity for the user.</div>}
          subDescription={'전문가 모드의 아웃링크 광고에서 사용된 각 CTA의 선호도와 클릭률을 분석해 가장 효과적인 옵션을 선정했습니다. 이를 통해 최소한의 CTA만 제공하여 사용자의 의사결정 복잡성을 줄였습니다.'}
      />
      <WorkFullImage image={design2} isMargin={true}/>
      
      <WorkTextSection 
          title={<div>Key Design3.<br/>To reduce decision-making complexity</div>} 
          description={<div>
              We have designed a user experience that takes into account the challenges of entering URLs on mobile devices, ensuring a seamless process across various devices. By researching the link copying environment of websites commonly used by small business owners, we identified potential issues and addressed them to minimize errors. This comprehensive approach ensures that users can successfully input URL.</div>}
          subDescription={'모바일에서 URL 입력이 어려운 점을 고려하여 다양한 기기에서 원활하게 입력할 수 있도록 UX를 설계했습니다. 소상공인이 자주 사용하는 웹사이트의 링크 복사 환경을 조사해 문제를 파악하고 오류를 최소화했습니다.'}
      />
      <WorkFullImage image={design3} isMargin={true}/>

      <WorkTextSection 
          title={<div>Key Design4.<br/>To integrate outlink ads naturally into a feed</div>} 
          description={<div>
              We insert ads in a format similar to regular posts in the feed, providing users with a seamless browsing experience and achieving a high Click-Through Rate(CTR).</div>}
          subDescription={'피드의 일반 게시물과 유사한 형식으로 광고를 삽입하여 이질감 없는 탐색 경험을 제공하고 높은 클릭률(CTR)을 달성했습니다.'}
      />
      <WorkFullImage image={design4} isMargin={true} isBottomMargin={true}/>
      
      <Wavedivider/>
          
      <WorkTextSection 
          title={<div>Result</div>} />
      <div className='image-center margin48 horizontal-layout'>
        <WorkFullImage image={result1} isMargin={false} isBottomMargin={true} />   
        <WorkFullImage image={result2} isMargin={false} isBottomMargin={true} />   
      </div>   
      <BackButton/>
      <NextItem to='/Work10' thumbnail={thumbnail10} nextProjectTitle='Eliminating Concerns of Creating Ads'/>
      <div style={{ height: "400px" }} />
      </>
      // </ProtectedPage>
    )
}

export default Work6;
